import { useFeatureStaticMenuQuery } from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

import { IParsedItemUnavailableModalData, IUseFeatureStaticMenu, requiredKeys } from './types';
import { parseData } from './utils';

// Regardless of his name, StaticMenu has nothing to do with this Feature
// This is a modal that's currently not used on RN
export const useFeatureStaticMenu = (): IUseFeatureStaticMenu => {
  const { featureStaticMenuId = '', featureIdsLoading } = useFeaturesContext();
  const { data, loading } = useFeatureStaticMenuQuery({
    variables: { featureStaticMenuId },
    skip: !featureStaticMenuId,
  });

  const featureStaticMenuLoading = featureIdsLoading || loading;
  const itemUnavailableModalData = data?.FeatureStaticMenu?.itemUnavailableModal;

  const itemUnavailableModal = parseData<IParsedItemUnavailableModalData>(
    itemUnavailableModalData,
    requiredKeys
  );

  return {
    itemUnavailableModal,
    featureStaticMenuLoading,
  };
};
